import classNames from 'classnames';

export const REGIONAL_SETTINGS_DROPDOWNS_MENU_CLASS =
  'RegionalSettingsDropdowns__menu';

export const getRegionalSettingsDropdownMenuClassName = ({
  isRounded,
  isBoxed,
}) =>
  classNames(REGIONAL_SETTINGS_DROPDOWNS_MENU_CLASS, {
    [`${REGIONAL_SETTINGS_DROPDOWNS_MENU_CLASS}--rounded`]: isRounded,
    [`${REGIONAL_SETTINGS_DROPDOWNS_MENU_CLASS}--box`]: isBoxed,
  });
